/**
 * Scenario 1 — Current Default = Checkbook VC, Balance on VC > 0
⚠️ Update needed! Payments to Checkbook Virtual Cards are no longer supported. Please select a new default payment method.
You can continue to use the existing funds on your checkbook virtual card until 11Sep2025. On 12Sep2025, the card will be closed, and any remaining balance will be transfered to your new default payment method on 15Sep2025.

Scenario 2 — Current Default = Checkbook VC, Balance on VC = 0
⚠️ Update needed! Payments to Checkbook Virtual Cards are no longer supported. Please select a new default payment method to receive any future transactions.

Scenario 3 — Current Default = Other, Balance on Checkbook VC > 0
⚠️ Action required! You currently have a remaining balance on your Checkbook Virtual Card, which will be closed on 12Sep2025.
Please use your remaining balance by 11Sep2025. Any unused funds will be transferred to your current default payment method on 15Sep2025.

Scenario 4 — Current Default = Other, Balance on Checkbook VC = 0
⚠️ Alert! No action is required, but this message is to notify you that your Checkbook Virtual card with a $0 balance will be closed on 12Sep2025.
*/
import {
  PaymentMethodsResponse,
  VirtualCardResponse,
} from "../types/paymentTypes";

export enum DeprecatedPaymentMethodStatus {
  UPDATE_NEEDED_WITH_BALANCE = "UPDATE_NEEDED_WITH_BALANCE",
  UPDATE_NEEDED_WITH_NO_BALANCE = "UPDATE_NEEDED_WITH_NO_BALANCE",
  ALERT_WITH_BALANCE = "ALERT_WITH_BALANCE",
  ALERT_WITH_NO_BALANCE = "ALERT_WITH_NO_BALANCE",
}

export function getDeprecatedPaymentMethodStatus(
  paymentMethodsData: PaymentMethodsResponse | null,
  virtualCards: VirtualCardResponse[]
): DeprecatedPaymentMethodStatus | null {
  if (!paymentMethodsData || !virtualCards) {
    return null;
  }

  // Find checkbook virtual card
  const checkbookCard = virtualCards.find(
    (card) => card.provider.toLowerCase() === "checkbook"
  );

  // If no checkbook card exists, no deprecation scenario applies
  if (!checkbookCard) {
    return null;
  }

  const hasBalance = checkbookCard.balance > 0;

  // Check if the current default payment method is a checkbook virtual card
  // by checking if it's a virtual card and matches the checkbook card ID
  const latestPaymentAccount = paymentMethodsData.latest_payment_account;
  const isCheckbookDefault =
    latestPaymentAccount?.target_account_type === "VIRTUAL_CARD" &&
    latestPaymentAccount?.target_account_id === checkbookCard.id;

  if (isCheckbookDefault) {
    return hasBalance
      ? DeprecatedPaymentMethodStatus.UPDATE_NEEDED_WITH_BALANCE
      : DeprecatedPaymentMethodStatus.UPDATE_NEEDED_WITH_NO_BALANCE;
  } else {
    return hasBalance
      ? DeprecatedPaymentMethodStatus.ALERT_WITH_BALANCE
      : DeprecatedPaymentMethodStatus.ALERT_WITH_NO_BALANCE;
  }
}
